export default "__VITE_ASSET__YvOy3z$k__"